<template>
    <div class="rl-root">

        <!-- Header -->
        <div class="rl-header">
            <div class="rl-header-left">
                <div class="rl-header-icon">
                    <i class="fas fa-list-alt"></i>
                </div>
                <div>
                    <h3 class="rl-title">Log da Campanha</h3>
                    <p class="rl-subtitle">{{ filtered.length }} registro(s)</p>
                </div>
            </div>
            <div class="rl-header-actions">
                <div class="rl-date-range">
                    <label class="rl-date-label">De</label>
                    <input class="rl-date-input" type="date" v-model="dateStart" @change="load" />
                    <label class="rl-date-label">Até</label>
                    <input class="rl-date-input" type="date" v-model="dateEnd" @change="load" />
                    <button v-if="dateStart || dateEnd" class="rl-date-clear" @click="clearDates" title="Limpar datas">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="rl-search-wrap">
                    <i class="fas fa-search rl-search-icon"></i>
                    <input class="rl-search" type="text" placeholder="Pesquisar..." v-model="search" />
                </div>
                <select class="rl-per-page" v-model="perPage">
                    <option :value="10">10 / pág</option>
                    <option :value="25">25 / pág</option>
                    <option :value="50">50 / pág</option>
                </select>
                <button class="rl-export-btn rl-export-btn--excel" @click="exportExcel" title="Exportar Excel">
                    <i class="fas fa-file-excel"></i> Excel
                </button>
                <button class="rl-export-btn rl-export-btn--pdf" @click="exportPdf" title="Exportar PDF">
                    <i class="fas fa-file-pdf"></i> PDF
                </button>
            </div>
        </div>

        <!-- Loading -->
        <div v-if="loading" class="rl-loading">
            <i class="fas fa-spinner fa-spin"></i> Carregando dados...
        </div>

        <!-- Tabela -->
        <div v-else class="rl-table-wrap">
            <table class="rl-table">
                <thead>
                    <tr>
                        <th class="rl-th sortable" @click="sortBy('created_at')">
                            Data <i :class="sortIcon('created_at')"></i>
                        </th>
                        <th class="rl-th sortable" @click="sortBy('nome_campanha')">
                            Campanha <i :class="sortIcon('nome_campanha')"></i>
                        </th>
                        <th class="rl-th">Telefone</th>
                        <th class="rl-th sortable" @click="sortBy('name')">
                            Cliente <i :class="sortIcon('name')"></i>
                        </th>
                        <th class="rl-th sortable" @click="sortBy('cpf_cnpj')">
                            CPF/CNPJ <i :class="sortIcon('cpf_cnpj')"></i>
                        </th>
                        <th class="rl-th sortable" @click="sortBy('status')">
                            Status <i :class="sortIcon('status')"></i>
                        </th>
                        <th class="rl-th sortable" @click="sortBy('updated_at')">
                            Última atualização <i :class="sortIcon('updated_at')"></i>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!paginated.length">
                        <td colspan="7" class="rl-empty">Nenhum registro encontrado.</td>
                    </tr>
                    <tr v-for="(row, i) in paginated" :key="i" class="rl-tr">
                        <td class="rl-td"><span class="rl-date">{{ formatDate(row.created_at) }}</span></td>
                        <td class="rl-td">
                            <div class="rl-campaign-cell">
                                <span class="rl-campaign-dot"></span>
                                <span class="rl-campaign">{{ row.nome_campanha }}</span>
                            </div>
                        </td>
                        <td class="rl-td">
                            <span class="rl-phone">
                                <i class="fab fa-whatsapp"></i> {{ formatPhone(row.telefone) }}
                            </span>
                        </td>
                        <td class="rl-td">{{ row.name || '—' }}</td>
                        <td class="rl-td">
                            <span v-if="row.cpf_cnpj" class="rl-mono">{{ row.cpf_cnpj }}</span>
                            <span v-else class="rl-muted">—</span>
                        </td>
                        <td class="rl-td">
                            <span class="rl-badge" :class="'rl-badge--' + row.status" :title="row.description || ''">
                                <i :class="statusIcon(row.status)"></i> {{ statusLabel(row.status) }}
                            </span>
                        </td>
                        <td class="rl-td"><span class="rl-date">{{ formatDateShort(row.updated_at) }}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Footer -->
        <div class="rl-footer">
            <span class="rl-info">{{ rangeStart }}–{{ rangeEnd }} de {{ filtered.length }} registros</span>
            <div class="rl-pagination">
                <button class="rl-page-btn" :disabled="page === 1" @click="page--">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <button v-for="p in visiblePages" :key="p" class="rl-page-btn"
                    :class="{ 'rl-page-btn--active': p === page }" @click="page = p">{{ p }}</button>
                <button class="rl-page-btn" :disabled="page === totalPages" @click="page++">
                    <i class="fas fa-chevron-right"></i>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: { filter: { type: Array, default: function () { return []; } } },
    data() {
        return {
            rows: [], loading: false, search: '', page: 1, perPage: 10,
            sortKey: 'created_at', sortDir: 'desc', dateStart: '', dateEnd: ''
        };
    },
    computed: {
        filtered() {
            var s = this.search.toLowerCase(), key = this.sortKey, dir = this.sortDir;
            var selected = (this.filter && this.filter.length) ? this.filter : null;

            var rows = this.rows;

            if (selected) {
                rows = rows.filter(function (r) { return selected.indexOf(r.nome_campanha) !== -1; });
            }

            if (s) {
                rows = rows.filter(function (r) {
                    return (r.nome_campanha || '').toLowerCase().includes(s)
                        || (r.telefone || '').includes(s)
                        || (r.name || '').toLowerCase().includes(s)
                        || (r.cpf_cnpj || '').includes(s)
                        || (r.status || '').includes(s);
                });
            }

            return rows.slice().sort(function (a, b) {
                var av = a[key] || '', bv = b[key] || '';
                return dir === 'asc' ? (av > bv ? 1 : -1) : (av < bv ? 1 : -1);
            });
        },
        totalPages() { return Math.max(1, Math.ceil(this.filtered.length / this.perPage)); },
        paginated() { var s = (this.page - 1) * this.perPage; return this.filtered.slice(s, s + this.perPage); },
        rangeStart() { return this.filtered.length ? (this.page - 1) * this.perPage + 1 : 0; },
        rangeEnd() { return Math.min(this.page * this.perPage, this.filtered.length); },
        visiblePages() {
            var total = this.totalPages, cur = this.page, pages = [];
            for (var i = Math.max(1, cur - 2); i <= Math.min(total, cur + 2); i++) pages.push(i);
            return pages;
        }
    },
    watch: {
        filter: { handler() { this.load(); }, deep: true },
        search() { this.page = 1; },
        perPage() { this.page = 1; }
    },
    methods: {
        async load() {
            this.loading = true;
            try {
                var params = {};
                if (this.filter && this.filter.length === 1) {
                    params.param = this.filter[0];
                } else {
                    params.param = 'todos';
                }
                if (this.dateStart) params.date_start = this.dateStart;
                if (this.dateEnd) params.date_end = this.dateEnd;
                var res = await axios.get('/marketing/log', { params });
                this.rows = Array.isArray(res.data) ? res.data : [];
            } catch (e) { this.rows = []; }
            this.loading = false;
        },
        clearDates() { this.dateStart = ''; this.dateEnd = ''; this.load(); },
        sortBy(key) {
            if (this.sortKey === key) this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
            else { this.sortKey = key; this.sortDir = 'asc'; }
            this.page = 1;
        },
        sortIcon(key) {
            if (this.sortKey !== key) return 'fas fa-sort rl-si';
            return this.sortDir === 'asc' ? 'fas fa-sort-up rl-si--on' : 'fas fa-sort-down rl-si--on';
        },
        formatPhone(p) { if (!p) return '—'; return p.includes('@s.whatsapp.net') ? p.split('@')[0] : p; },
        formatDate(d) { return d ? moment(d).format('DD/MM/YYYY HH:mm:ss') : '—'; },
        formatDateShort(d) { return d ? moment(d).format('DD/MM/YY [às] HH:mm') : '—'; },
        statusLabel(s) {
            return { pending: 'Pendente', sent: 'Enviada', delivered: 'Entregue', read: 'Lida', failed: 'Falha', deleted: 'Deletada' }[s] || s;
        },
        statusIcon(s) {
            return { pending: 'fas fa-clock', sent: 'fas fa-check', delivered: 'fas fa-check-double', read: 'fas fa-check-double', failed: 'fas fa-times-circle', deleted: 'fas fa-trash' }[s] || 'fas fa-circle';
        },

        _exportRows() {
            return this.filtered.map(function (r) {
                return {
                    'Data': r.created_at ? moment(r.created_at).format('DD/MM/YYYY HH:mm:ss') : '—',
                    'Campanha': r.nome_campanha || '—',
                    'Telefone': r.telefone ? (r.telefone.includes('@s.whatsapp.net') ? r.telefone.split('@')[0] : r.telefone) : '—',
                    'Cliente': r.name || '—',
                    'CPF/CNPJ': r.cpf_cnpj || '—',
                    'Status': { pending: 'Pendente', sent: 'Enviada', delivered: 'Entregue', read: 'Lida', failed: 'Falha', deleted: 'Deletada' }[r.status] || r.status || '—',
                    'Última atualização': r.updated_at ? moment(r.updated_at).format('DD/MM/YY HH:mm') : '—',
                    'Motivo da falha': r.status === 'failed' ? (r.description || '—') : '—'
                };
            });
        },

        exportExcel() {
            var self = this;
            function doExport() {
                var XLSX = window.XLSX;
                var data = self._exportRows();
                var ws = XLSX.utils.json_to_sheet(data);
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Log');
                XLSX.writeFile(wb, 'log_campanha_' + moment().format('YYYYMMDD_HHmm') + '.xlsx');
            }
            if (window.XLSX) { doExport(); return; }
            var s = document.createElement('script');
            s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
            s.onload = doExport;
            document.head.appendChild(s);
        },

        exportPdf() {
            var self = this;
            function doExport() {
                var doc = new window.jspdf.jsPDF({ orientation: 'landscape' });
                doc.setFontSize(13);
                doc.text('Log da Campanha', 14, 15);
                doc.setFontSize(9);
                doc.text('Gerado em ' + moment().format('DD/MM/YYYY HH:mm'), 14, 21);
                var rows = self._exportRows();
                var cols = Object.keys(rows[0] || {});
                doc.autoTable({
                    startY: 26,
                    head: [cols],
                    body: rows.map(function (r) { return cols.map(function (c) { return r[c]; }); }),
                    styles: { fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [0, 168, 132], textColor: 255, fontStyle: 'bold' },
                    alternateRowStyles: { fillColor: [248, 249, 250] },
                    columnStyles: { 0: { cellWidth: 34 }, 6: { cellWidth: 28 }, 7: { cellWidth: 55 } }
                });
                doc.save('log_campanha_' + moment().format('YYYYMMDD_HHmm') + '.pdf');
            }
            if (window.jspdf && window.jspdf.jsPDF) { doExport(); return; }
            var s1 = document.createElement('script');
            s1.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
            s1.onload = function () {
                var s2 = document.createElement('script');
                s2.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js';
                s2.onload = doExport;
                document.head.appendChild(s2);
            };
            document.head.appendChild(s1);
        }
    },
    mounted() { this.load(); }
};
</script>

<style scoped>
.rl-root {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.rl-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px 16px;
    flex-wrap: wrap;
    gap: 12px;
}

.rl-header-left {
    display: flex;
    align-items: center;
    gap: 14px;
}

.rl-header-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px !important;
    background: linear-gradient(135deg, #00a884, #00c49a);
    display: flex;
    align-items: center;
    justify-content: center;
}

.rl-header-icon i {
    font-size: 18px;
    color: #fff;
}

.rl-title {
    font-size: 16px;
    font-weight: 700;
    color: #111b21;
    margin: 0;
    line-height: 1.2;
}

.rl-subtitle {
    font-size: 12px;
    color: #adb5bd;
    margin: 0;
    margin-top: 2px;
}

.rl-header-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.rl-search-wrap {
    position: relative;
}

.rl-search-icon {
    position: absolute;
    left: 11px;
    top: 50%;
    transform: translateY(-50%);
    color: #adb5bd;
    font-size: 12px;
    pointer-events: none;
}

.rl-search {
    height: 36px;
    padding: 0 12px 0 32px;
    border: 1.5px solid #e9edef;
    border-radius: 8px !important;
    font-size: 13px;
    color: #111b21;
    outline: none;
    width: 200px;
    transition: border-color .15s;
}

.rl-search:focus {
    border-color: #00a884;
}

.rl-per-page {
    height: 36px;
    padding: 0 10px;
    border: 1.5px solid #e9edef;
    border-radius: 8px !important;
    font-size: 13px;
    color: #495057;
    outline: none;
    cursor: pointer;
}

.rl-date-range {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #f8f9fa;
    border: 1.5px solid #e9edef;
    border-radius: 8px !important;
    padding: 0 10px;
    height: 36px;
}

.rl-date-label {
    font-size: 11px;
    font-weight: 600;
    color: #adb5bd;
    white-space: nowrap;
}

.rl-date-input {
    height: 28px;
    padding: 0 4px;
    border: none;
    background: transparent;
    font-size: 13px;
    color: #111b21;
    outline: none;
    width: 130px;
}

.rl-date-input:focus {
    color: #00a884;
}

.rl-date-clear {
    width: 22px;
    height: 22px;
    border: none;
    border-radius: 50% !important;
    background: #fecdd3;
    color: #be123c;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    flex-shrink: 0;
}

.rl-date-clear:hover {
    background: #fca5a5;
}

.rl-export-btn {
    height: 36px;
    padding: 0 12px;
    border: 1.5px solid;
    border-radius: 8px !important;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: background .15s, color .15s;
    white-space: nowrap;
}

.rl-export-btn--excel {
    background: #f0fdf4;
    border-color: #bbf7d0;
    color: #15803d;
}

.rl-export-btn--excel:hover {
    background: #dcfce7;
}

.rl-export-btn--pdf {
    background: #fff1f2;
    border-color: #fecdd3;
    color: #be123c;
}

.rl-export-btn--pdf:hover {
    background: #ffe4e6;
}

.rl-loading {
    padding: 48px;
    text-align: center;
    font-size: 14px;
    color: #adb5bd;
}

.rl-loading i {
    margin-right: 6px;
    color: #00a884;
}

.rl-table-wrap {
    overflow-x: auto;
    border-top: 1px solid #f0f2f5;
}

.rl-table {
    width: 100%;
    border-collapse: collapse;
}

.rl-th {
    background: #fafbfc;
    color: #64748b;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .05em;
    padding: 10px 16px;
    border-bottom: 1px solid #f0f2f5;
    text-align: left;
    white-space: nowrap;
}

.rl-th.sortable {
    cursor: pointer;
    user-select: none;
    transition: background .1s;
}

.rl-th.sortable:hover {
    background: #f0f2f5;
}

.rl-tr {
    border-bottom: 1px solid #f8f9fa;
    transition: background .1s;
}

.rl-tr:hover {
    background: #f8fffe;
}

.rl-td {
    padding: 12px 16px;
    font-size: 13px;
    color: #343a40;
    vertical-align: middle;
}

.rl-empty {
    padding: 48px;
    text-align: center;
    font-size: 13px;
    color: #adb5bd;
}

.rl-date {
    font-size: 12px;
    color: #94a3b8;
}

.rl-campaign-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.rl-campaign-dot {
    width: 7px;
    height: 7px;
    border-radius: 50% !important;
    background: #00a884;
    flex-shrink: 0;
}

.rl-campaign {
    font-weight: 600;
    color: #111b21;
}

.rl-phone {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: #25d366;
    font-size: 12px;
}

.rl-mono {
    font-family: monospace;
    font-size: 12px;
    color: #495057;
}

.rl-muted {
    color: #adb5bd;
    font-size: 12px;
}

.rl-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 99px !important;
    white-space: nowrap;
}

.rl-badge--pending {
    background: #fef9c3;
    color: #a16207;
}

.rl-badge--sent {
    background: #f1f5f9;
    color: #475569;
}

.rl-badge--delivered {
    background: #dbeafe;
    color: #1d4ed8;
}

.rl-badge--read {
    background: #dcfce7;
    color: #15803d;
}

.rl-badge--failed {
    background: #ffe4e6;
    color: #be123c;
}

.rl-badge--deleted {
    background: #ffe4e6;
    color: #be123c;
}

.rl-si {
    color: #d1d5db;
    font-size: 10px;
    margin-left: 3px;
}

.rl-si--on {
    color: #00a884;
    font-size: 10px;
    margin-left: 3px;
}

.rl-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    border-top: 1px solid #f0f2f5;
    flex-wrap: wrap;
    gap: 8px;
}

.rl-info {
    font-size: 12px;
    color: #adb5bd;
}

.rl-pagination {
    display: flex;
    align-items: center;
    gap: 4px;
}

.rl-page-btn {
    min-width: 34px;
    height: 34px;
    padding: 0 8px;
    background: #fff;
    border: 1.5px solid #e9edef;
    border-radius: 8px !important;
    font-size: 12px;
    color: #495057;
    cursor: pointer;
    transition: all .15s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.rl-page-btn:hover:not(:disabled):not(.rl-page-btn--active) {
    background: #f0f2f5;
    border-color: #dee2e6;
}

.rl-page-btn--active {
    background: #00a884;
    border-color: #00a884;
    color: #fff;
    font-weight: 700;
}

.rl-page-btn:disabled {
    opacity: .35;
    cursor: not-allowed;
}
</style>